import { Component, Input, NgZone, OnInit, inject } from '@angular/core';
import { Bind } from 'primeng/bind';
import { ProgressBar } from 'primeng/progressbar';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    imports: [Bind, ProgressBar]
})
export class ProgressBarComponent implements OnInit {
    private ngZone = inject(NgZone);

    @Input() mode: 'determinate' | 'indeterminate' = 'determinate';
    @Input() progressValue?: number; // 0-100

    @Input() showValue = true;
    @Input() defaultTotalDurationMs = 5000;

    @Input() messages: string[];

    currentMessageIndex: number;
    interval: any;
    messagesInterval: any;

    ngOnInit(): void {

        if (this.progressValue >= 0) {

        } else if (this.mode === 'determinate') {
            this.progressValue = 0;
            this.ngZone.runOutsideAngular(() => {
                this.interval = setInterval(() => {
                    this.ngZone.run(() => {
                        this.progressValue = Math.min(this.progressValue + 1, 100);
                        if (this.progressValue >= 99) {
                            clearInterval(this.interval);
                        }
                    });
                }, 1500);
            });
        }

        if (this.messages) {
            this.currentMessageIndex = 0;
            this.ngZone.runOutsideAngular(() => {
                this.messagesInterval = setInterval(() => {
                    this.ngZone.run(() => {
                        this.currentMessageIndex = Math.floor(Math.random() * this.messages.length);
                    });
                }, 3500);
            });
        }



    }
}
